import React from "react";
import ViewerView from "./ViewerView";
import useViewerView from "./useViewerView";

function Viewer() {
  return <ViewerView {...useViewerView()} />;
}

export default Viewer;
